<template>
  <div id="confirmation" class="">
    <div class="c-infobox text-center">
      <h1>
        <b>{{ $t("lang.label_password_reset_result_title") }}</b>
      </h1>
      <p>
        {{ $t("lang.label_password_reset_result_text") }}
      </p>
      <p>
        <b>{{ $t("lang.label_email_not_received") }}</b>
        <br />
        <b-button variant="link" @click="resendVerificationEmail">{{ $t("lang.label_resend_email") }}</b-button>
      </p>
      <p>
        <router-link to="/login">{{ $t("lang.label_signIn") }}</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import API from "@/api";
export default {
  name: "ResetPasswordEmailNotification",
  methods: {
    resendVerificationEmail() {
      API.resendResetPasswordEmail(this.$route.params.userEmail)
        .then(() => {
          this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_password_reset_email_sent_success"));
        })
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_password_reset_email_sent_error"));
        });
    }
  }
};
</script>
<style scoped></style>
